/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabase";
import { setSuperAdminCache } from "../utils/superAdmin";

// AUD-05 P2: the own-row columns the app reads off myProfile — this file (role, is_super_admin,
// preferences.sort_by / .favorites, designer_names, my_designer_name), Home (id, display_name,
// preferences, my_designer_name), the drawer and item handlers (display_name), the frame modals
// (can_add_brands), the designer workspaces (is_super_admin, my_designer_name). Was select('*').
const OWN_PROFILE_COLUMNS = "id,role,is_super_admin,preferences,designer_names,my_designer_name,display_name,can_add_brands";

export function useAuthSetup({ user, setSortBy, setFavorites }) {
  const [role, setRole] = useState("viewer");
  const [myProfile, setMyProfile] = useState(null);
  const [userNameMap, setUserNameMap] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [allDesignerNames, setAllDesignerNames] = useState([]);
  const favSyncedRef = useRef(false);

  useEffect(() => {
    supabase.from("user_profiles").select(OWN_PROFILE_COLUMNS).eq("id", user.id).single()
      .then(({ data }) => {
        if (data?.role) setRole(data.role.toLowerCase());
        if (data) { setMyProfile(data); setSuperAdminCache(user.id, !!data.is_super_admin); }
        if (data?.preferences?.sort_by) setSortBy(data.preferences.sort_by);
        else { try { const ls = localStorage.getItem("clb_sort"); if (ls) setSortBy(ls); } catch(e){ if (process.env.NODE_ENV !== 'production') console.warn('[localStorage:sort_read]', e?.message || e); } }
        if (data?.preferences?.favorites && !favSyncedRef.current) {
          favSyncedRef.current = true;
          setFavorites(prev => {
            const merged = { ...prev, ...data.preferences.favorites };
            try { localStorage.setItem("clb_favorites", JSON.stringify(merged)); } catch(e) { if (process.env.NODE_ENV !== 'production') console.warn('[localStorage:favorites_merge]', e?.message || e); }
            return merged;
          });
        }
      });
    supabase.from("user_profiles_public").select("email,display_name,role,designer_names,my_designer_name").then(({ data }) => {
      if (data) {
        const map = {}; data.forEach(u => { if (u.email && u.display_name) map[u.email] = u.display_name; });
        setUserNameMap(map);
        setAllUsers(data.filter(u => u.role === "admin" || u.role === "editor"));
        // Flat sorted list of all designer names across all profiles
        const names = [...new Set(data.flatMap(u => u.designer_names || []).filter(Boolean))].sort();
        setAllDesignerNames(names);
      }
    });
  }, [user.id]);

  // Strict: only use confirmed designer_names from profile.
  // NO email-prefix fallback — that caused cross-designer leakage.
  // Non-designer users (no designer_names set) get [] → see nothing.
  const myDesignerNames = (myProfile?.designer_names || []).map(n => n.toLowerCase());

  // Identity: single name that identifies THIS user for dev request filtering.
  // Separate from designer_names (visibility) — prevents cross-designer leakage.
  const myDesignerIdentity = myProfile?.my_designer_name || '';

  return { role, setRole, myProfile, setMyProfile, userNameMap, allUsers, myDesignerNames, allDesignerNames, myDesignerIdentity };
}
